<mat-progress-bar *ngIf="progress$ | async" color="accent" mode="indeterminate" value="0" @progress></mat-progress-bar>

<div *ngIf="background" @background class="background"></div>

<router-outlet></router-outlet>